import React from 'react';
import { Toast } from 'react-bootstrap';
import { useIntl } from 'react-intl';

export interface IToastProps {
  active: boolean;
  heading: string;
  text: string;
  type: string;
  setActive: (active: boolean) => void;
}

export const ToastWrap  = (props: IToastProps) => {
  const intl = useIntl();
  return (
    <>
      { props.active &&
      <div className="toast-wrap" aria-live="assertive" aria-atomic="true">
        <div className="container">
          <Toast className={"toast " + props.type} onClose={() => props.setActive(false)}>
            <Toast.Header className="toast-header" closeLabel={intl.formatMessage({id: 'button.close'})}>
              <i className="fa fa-warning me-2"></i>
              <strong className="me-auto">
                {props.heading}
              </strong>
            </Toast.Header>
            {props.text &&
            <Toast.Body className="toast-body">
              {props.text}
            </Toast.Body>
            }
          </Toast>
        </div>
      </div>
      }
    </>
  );
}
